module.exports = __webpack_public_path__ + "img/multimodal_mental_health_dx_4.65e17b24.png";